// src/components/PrivacyPolicy/PrivacyPolicy.jsx
import PrivacyPolicyHelmetComponent from "./PrivacyPolicyHelmetComponent";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton"; // polku tarpeen mukaan
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {

  const navigate = useNavigate();

  return (
    <div>
      <PrivacyPolicyHelmetComponent />

      <div className="dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 pb-10 py-5 p-5 max-w-7xl mx-auto pt-24">

      <ResponsiveButton
        onClick={() => {
          if (window.history.length > 2) {
            navigate(-1);
          } else {
            navigate("/");
          }
          setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
        }}
        variant="backbutton"
        className="ml-4"
      >
        <div className="flex items-center gap-2">
          <MdArrowBack className="text-xl" />
          <span>Takaisin</span>
        </div>
      </ResponsiveButton>


        {/* Sivun otsikko */}
        <div className="flex flex-row items-center mt-5">
          <h1 className="site-title font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-5xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-[1.2]">
            Spiderlegs Productions Tietosuojalausunto
          </h1>
        </div>

        {/* 1. Johdanto */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            1. Johdanto
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mt-4">
            Spiderlegs Productions Oy (Y-tunnus: 3214378-6) kunnioittaa asiakkaidensa yksityisyyttä ja on sitoutunut noudattamaan henkilötietolakia (2016/679) sekä muita tietosuojaan liittyviä säädöksiä. Tämä tietosuojalausunto kuvaa, miten keräämme, käytämme ja käsittelemme henkilötietojasi verkkosivustollamme ja sen kautta.
          </p>
        </div>

        {/* 2. Henkilötietojen kerääminen */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            2. Henkilötietojen kerääminen
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Keräämme verkkosivustollamme olevien yhteydenottolomakkeiden kautta saapuneita tietoja. Keräämämme tiedot ovat:
          </p>
          <ul className="list-disc pl-5 mt-2 text-xl font-light text-darkest dark:text-primary">
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-normal">Nimi:</strong> Varaajan nimi.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Sähköpostiosoite:</strong> Varaajan sähköpostiosoite.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Puhelinnumero:</strong> Varaajan puhelinnumero.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Tapahtumapaikka:</strong> Tapahtuman järjestämispaikka.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Aloituspäivämäärä:</strong> Varaustapahtuman aloituspäivämäärä.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Rekisterinumero:</strong> Peräkärryn vuokrauksen yhteydessä.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Lopetuspäivämäärä:</strong> Varaustapahtuman lopetuspäivämäärä.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Viesti:</strong> Varaajan jättämä viesti tai lisätiedot.
            </li>
            <li>
              <strong className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-normal">Tietojen tallennuksen ajankohta:</strong> Tietojen tallennuksen ajankohta.
            </li>
          </ul>
        </div>

        {/* 3. Henkilötietojen käyttö */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            3. Henkilötietojen käyttö
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Käytämme lomakkeen kautta tulleita tietoja ainoastaan:
            <br />
            • Vastataaksemme kysymyksiisi ja yhteydenottopyyntöihisi.<br />
            • Ylläpitääksemme asiakassuhdetta kanssasi.<br />
            • Tarjotaksemme sinulle räätälöityjä palveluita ja tarjouksia.
          </p>
        </div>

        {/* 4. Henkilötietojen jakaminen */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            4. Henkilötietojen jakaminen
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Emme jaa henkilötietojasi kolmansien osapuolten kanssa ilman suostumustasi, paitsi jos laki niin määrää tai jos se on tarpeen palveluidemme tarjoamiseksi.
          </p>
        </div>

        {/* 5. Henkilötietojen säilytys */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            5. Henkilötietojen säilytys
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Säilytämme henkilötietojasi vain niin kauan kuin on tarpeen edellä mainittujen käyttötarkoitusten täyttämiseksi tai lain edellyttämien määräaikojen mukaan.
          </p>
        </div>

        {/* 6. Tietoturva */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            6. Tietoturva
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Käytämme asianmukaisia teknisiä ja organisatorisia toimenpiteitä suojataksemme henkilötietojasi luvattomalta käsittelyltä, käytöltä, paljastamiselta, muuttamiselta tai tuhoamiselta.
          </p>
        </div>

        {/* 7. Oikeutesi */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            7. Oikeutesi
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Sinulla on oikeus:
            <br />
            • Saada tietoa siitä, miten käsittelemme henkilötietojasi.<br />
            • Pyytää henkilötietojesi oikaisemista tai poistamista.<br />
            • Rajoittaa henkilötietojesi käsittelyä.<br />
            • Vastustaa henkilötietojesi käsittelyä.
          </p>
        </div>

        {/* 8. Yhteystiedot */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            8. Yhteystiedot
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Jos sinulla on kysyttävää henkilötietojesi käsittelystä tai haluat käyttää oikeuksiasi, ota yhteyttä:
            <br /><br />
            Spiderlegs Productions<br />
            Arttu Stenius<br />
            +358 44 351 92 65<br />
            Sähköposti:{" "}
            <a
              href="mailto:info@spiderlegsproductions.com?body=My custom mail body"
              title="Lähetä sähköpostia"
              className="text-violet"
            >
              info@spiderlegsproductions.com
            </a>
          </p>
        </div>

        {/* 9. Muutokset */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            9. Muutokset
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Tätä tietosuojalausuntoa voidaan päivittää ajoittain. Ilmoitamme sinulle kaikista merkittävistä muutoksista verkkosivustollamme.
          </p>
        </div>

        {/* 10. Tietosuoja */}
        <div className="mt-8">
          <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
            10. Tietosuoja
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-4">
            Lisätietoja tietosuojalainsäädännöstä saat tietosuojavaltuutetun verkkosivuilta:
            <br /><br />
            <a href="https://www.tietosuoja.fi/" title="Klikkaa sivulle" className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light">
              https://www.tietosuoja.fi/
            </a>
          </p>
          <br />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
